import { Injectable, Inject, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { getQueryParam } from '@shared/helpers/url.helper';

interface ITheme {
  name: string;
  baseColor?: string;
  isActive?: boolean;
}

@Injectable()
export class ThemeService {
  public egretThemes: ITheme[] = [{
    'name': 'egret-dark-purple',
    'baseColor': '#9c27b0',
    'isActive': false
  }, {
    'name': 'egret-dark-pink',
    'baseColor': '#e91e63',
    'isActive': false
  }, {
    'name': 'egret-blue',
    'baseColor': '#247ba0',
    'isActive': true
  }, {
    'name': 'egret-indigo',
    'baseColor': '#3f51b5',
    'isActive': false
  }];
  public activatedTheme: ITheme;
  private dataColors = {
    pending: '#3C7D26',
    accepted: '#FFC038',
    cancelled: '#5F4CA1',
    completed: '#1A55A4',
    approved: '#407DC5',
    active: '#64A24D',
    inactive: '#380000',
    paid: '#EF6C00',
    delivered: '#4E342E',

    quote_required: '#64A24D',
    compliance_to_sign_off: '#5F4CA1',
    audit_service: '#247ba0',

    ppm: '#3C7D26',
    capital: '#FFC038',
    reactive: '#e91e63',
    create_quotation: '#1A55A4',

    not_trading: '#3C7D26',
    to_be_assigned: '#407DC5',

    uf: '#3e56a0',
    capex: '#247ba0',

    logged: '#3C7D26',
    assigned: '#247ba0',
    in_progress: '#07a029',

    client: '#FFC038',
    supplier: '#247ba0',
    service_supplier: '#3e56a0',
    product_supplier: '#07a029',
    no_company: '#75a011',
    agent: '#3C7D26',

    open_health_and_safety: '#3C7D26',
    open_non_compliant: '#247ba0',
    open_business_critical: '#1A55A4',
    out_standing_quote: '#FFC038',

    // quotation status
    client_review: '#3C7D26',
    declined: '#e91e63',
    declined_with_message: '#EF6C00',
    awaiting: '#3e56a0',
    quoted: '#75a011',
    failed_benchmarking: '#1A55A4',
    holding_pool: '#3C7D26',
    more_info: '#FFC038',
    collected: '#67de',
    invoiced: '#21de',
    issued: '#3d8',
  };

  constructor(
    @Inject(DOCUMENT) private document: Document
  ) {
  }

  // Invoked in AppComponent and apply 'activatedTheme' on startup
  applyMatTheme(r: Renderer2) {
    /*
    ****** (SET YOUR DEFAULT THEME HERE) *******
    * Assign new Theme to activatedTheme
    */
    // this.activatedTheme = this.egretThemes[0];
    // this.activatedTheme = this.egretThemes[1];
    this.activatedTheme = this.egretThemes[2];
    // this.activatedTheme = this.egretThemes[3];

    // *********** ONLY FOR DEMO **********
    this.setThemeFromQuery();
    // ************************************

    this.changeTheme(r, this.activatedTheme);
  }

  changeTheme(r: Renderer2, theme: ITheme) {
    r.removeClass(this.document.body, this.activatedTheme.name);
    r.addClass(this.document.body, theme.name);
    this.flipActiveFlag(theme);
  }

  flipActiveFlag(theme: ITheme) {
    this.egretThemes.forEach((t) => {
      t.isActive = false;
      if (t.name === theme.name) {
        t.isActive = true;
        this.activatedTheme = theme;
      }
    });
  }

  // *********** ONLY FOR DEMO **********
  setThemeFromQuery() {
    let themeStr = getQueryParam('theme');
    try {
      this.activatedTheme = JSON.parse(themeStr);
      this.flipActiveFlag(this.activatedTheme);
    } catch (e) {
    }
  }

  getStrColor(str) {
    if (this.dataColors.hasOwnProperty(str)) {
      return this.dataColors[str];
    } else {
      return '#032965';
    }
  }
}
